import app from "./admin/app.js";
import user from "./admin/user.js";

export default {
    app,
    user
};